import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["box", "button", "icon"]
  static values = {
    collapsed: Boolean,
    folderId: String,
    updateUrl: String,
  }

  connect() {
    this.applyState()
  }

  toggle(event) {
    // Allow clicks on actions (e.g. Turbo modal links) without toggling.
    if (event.target.closest(".button-group")) return

    event.preventDefault()
    this.collapsedValue = !this.collapsedValue
    this.applyState()
    this.persistState()
  }

  applyState() {
    this.boxTarget.classList.toggle("hidden", this.collapsedValue)
    this.buttonTarget.setAttribute("aria-expanded", String(!this.collapsedValue))

    if (this.collapsedValue) {
      this.iconTarget.classList.remove("fa-chevron-down")
      this.iconTarget.classList.add("fa-chevron-right")
    } else {
      this.iconTarget.classList.remove("fa-chevron-right")
      this.iconTarget.classList.add("fa-chevron-down")
    }
  }

  persistState() {
    if (!this.hasUpdateUrlValue || !this.hasFolderIdValue) return

    fetch(this.updateUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        Accept: "application/json",
      },
      body: JSON.stringify({
        folder_id: this.folderIdValue,
        collapsed: this.collapsedValue,
      }),
    })
  }
}